import { render, staticRenderFns } from "./AppCosts.vue?vue&type=template&id=32f19ed0&scoped=true&"
import script from "./AppCosts.vue?vue&type=script&lang=js&"
export * from "./AppCosts.vue?vue&type=script&lang=js&"
import style0 from "./AppCosts.vue?vue&type=style&index=0&id=32f19ed0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f19ed0",
  null
  
)

export default component.exports